interface Props {
    className?: string
}

export default function ExclamationMark({className = ''}: Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M12.45 6C12.6157 6 12.75 6.13432 12.75 6.3L12.75 12.3C12.75 12.9627 12.2127 13.5 11.55 13.5C11.3843 13.5 11.25 13.3657 11.25 13.2L11.25 7.2C11.25 6.53726 11.7873 6 12.45 6Z"
                fillRule="evenodd"
                clipRule="evenodd" />
            <path
                d="M12.45 15C11.7873 15 11.25 15.5373 11.25 16.2V16.95C11.25 17.1157 11.3843 17.25 11.55 17.25C12.2127 17.25 12.75 16.7127 12.75 16.05V15.3C12.75 15.1343 12.6157 15 12.45 15Z"
                fillRule="evenodd"
                clipRule="evenodd" />
            <path
                d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                fillRule="evenodd"
                clipRule="evenodd" />
        </svg>
    )
}
